import { AppState } from '@/store';
import { createSelector } from 'reselect';

export const getMessages = (state: AppState) => state.messages;
export const getMessagesData = createSelector(getMessages, messages => messages.data);
export const getMessagesStatuses = createSelector(
  getMessages,
  messages => messages.status,
);
